import React, {useEffect, useRef, useState} from "react";
import {connect} from "react-redux";
import PropTypes from "prop-types";

import {getCurrentLayout} from "../../appLayout";
import {getAvailableLayouts} from "./navUtils";
import LayoutNavigationItem from "../layoutNavigationItem";

const DesktopNavigationLayoutsContent = (props) => {

  const {handleLayoutItemClick, desktopNavigationOpened} = props;

  const [allowLoading, setAllowLoading] = useState(desktopNavigationOpened);
  const timeoutRef = useRef();

  useEffect(() => {
    timeoutRef.current = setTimeout(() => {
      setAllowLoading(true);
    }, allowLoading ? 300 : 400)
    return () => {
      clearTimeout(timeoutRef.current)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!allowLoading) {
    return null
  }

  const layout = getCurrentLayout();
  const layoutNames = getAvailableLayouts();
  return (
    <div className='layout'>
      <ul className="layout-list">
        {layoutNames.map(key => {
          return <LayoutNavigationItem layout={layout}
                                       key={key}
                                       keyType={key}
                                       handleLayoutItemClick={handleLayoutItemClick}/>
        })}
      </ul>
    </div>
  )
}

DesktopNavigationLayoutsContent.propTypes = {
  handleLayoutItemClick: PropTypes.func,
}

const mapStateToProps = (store) => {
  const {desktopNavigationOpened} = store.navigationState;
  return {
    desktopNavigationOpened
  };
};

export default connect(mapStateToProps)(DesktopNavigationLayoutsContent);
